import { Link } from "@fluidattacks/design";
import type { CellContext } from "@tanstack/react-table";
import * as React from "react";
import { useCallback } from "react";
import { useParams } from "react-router-dom";

import type { TDockerImage } from "../../hooks";
import { usePackagesStore } from "pages/group/supply-chain/all-packages-tab/hooks/use-packages-store";

interface IPackagesColumnProps {
  readonly details: TDockerImage;
}

const PackagesColumn: React.FC<IPackagesColumnProps> = ({
  details,
}): React.JSX.Element => {
  const { groupName, organizationName } = useParams();
  const setImages = usePackagesStore(
    (store): ((images: string[]) => void) => store.setImages,
  );

  const onClick = useCallback((): void => {
    setImages([details.uri]);
  }, [details.uri, setImages]);

  return (
    <Link
      href={`/orgs/${organizationName}/groups/${groupName}/inventory/packages/all-packages`}
      onClick={onClick}
    >
      {`View packages (${details.toePackagesConnection.total})`}
    </Link>
  );
};

const formatPackagesColumn = (
  cell: CellContext<TDockerImage, unknown>,
): React.JSX.Element => {
  const details = cell.row.original;

  return <PackagesColumn details={details} />;
};

export { formatPackagesColumn };
